import InputTextField from "@/components/InputTextField/InputTextField";
import { useMetadataFields } from "@/components/MetadataFields/hooks";

type Props = {
  disabled: boolean;
};

export function OtherNegotiatedUsageRights({ disabled }: Props) {
  const { activeAsset, updateMetadata, isMetadataUpdating } =
    useMetadataFields();
  const isUpdating = isMetadataUpdating(
    activeAsset.id!,
    "otherNegotiatedUsageRights",
  );
  return (
    <InputTextField
      id="otherNegotiatedUsageRights"
      labelText="Other Negotiated UsageRights"
      toolTipText="Are there any specific rules in how the asset(s) are to be used? This could include a specific time period, specific contexts, specific teams or any other restrictions there might be."
      initialValue={activeAsset.otherNegotiatedUsageRights || ""}
      onBlur={(value: string) =>
        updateMetadata({
          otherNegotiatedUsageRights: value,
        })
      }
      disabled={disabled || isUpdating}
    />
  );
}
